import React, { useEffect, useState } from 'react'
import './privacypolicy.css'
import { Link } from 'react-router-dom'
import axios from 'axios';

function PrivacyTerms() {
      const [privacypolicy, setPrivacyPolicy] = useState('')
      const [terms, setTermsCondition] = useState('')
     useEffect(() => {
          getPages()
      }, []);
      const getPages = () => {
        let config = {
            method: 'get',
            maxBodyLength: Infinity,
            url: `${process.env.REACT_APP_API_URL}/pages`,
            headers: {
                'Authorization': localStorage.getItem('dastaan__token'),
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };
        axios.request(config).then((response) => {
            const data = response.data.data
            data.map((item) => {
                switch (item.page_name) {
                    case "Terms and Condition":
                        setTermsCondition(`pages/${item.page_name}`)
                        break;
                   
                    case "Privacy Policy":
                        setPrivacyPolicy(`pages/${item.page_name}`)
                        break;
                }
            })
        })
    }
  return (
    <div className='terms-privacy-wrapper'>
        <span className='plain-text main'>
            By Continuing you agree to our <Link to={'/' + terms}><span className='link'>Terms Of Use </span> </Link>
            and acknowledge that you have read our
            <Link to={'/' + privacypolicy}> <span className='link'> Privacy Policy.</span> </Link>
            
        </span>
    </div>
  )
}

export default PrivacyTerms